import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { JsError } from "$/modules/ttml-processor/types";

export const hasDismissedSyllableSmoothingTipAtom = atomWithStorage(
	"hasDismissedSyllableSmoothingTip",
	false,
);

export const importFromTextDialogAtom = atom(false);
export const metadataEditorDialogAtom = atom(false);
export const settingsDialogAtom = atom(false);
export const settingsTabAtom = atom("common");
export const latencyTestDialogAtom = atom(false);
export const submitToAMLLDBDialogAtom = atom(false);
export const splitWordDialogAtom = atom(false);
export const replaceWordDialogAtom = atom(false);
export const advancedSegmentationDialogAtom = atom(false);
export const timeShiftDialogAtom = atom(false);
export const syllableSmoothingDialogAtom = atom(false);
export const distributeRomanizationDialogAtom = atom(false);
export const confirmDialogAtom = atom<{
	open: boolean;
	title: string;
	description: string;
	onConfirm?: () => void;
}>({
	open: false,
	title: "",
	description: "",
});
export const historyRestoreDialogAtom = atom(false);
export const importFromLRCLIBDialogAtom = atom(false);
export const ttmlErrorDialogAtom = atom<{
	error: JsError;
	rawText?: string;
} | null>(null);
